import style from "./CertificateConditions.module.css";
import {
  isConditionsHtml,
  sanitizeConditionsHtml,
} from "../../utils/certificateConditions";

/**
 * Read-only view of the certificate conditions on the L1 / L2 / L3 review
 * screens, with the bold text and numbers set in Admin. Old plain-text
 * conditions show line by line.
 */
const CertificateConditionsView = ({ value }: { value?: string }) => {
  if (!value) {
    return <div className={style.view}>--</div>;
  }
  if (!isConditionsHtml(value)) {
    return <div className={`${style.view} ${style.plain}`}>{value}</div>;
  }
  return (
    <div
      className={style.view}
      dangerouslySetInnerHTML={{ __html: sanitizeConditionsHtml(value) }}
    />
  );
};

export default CertificateConditionsView;
